import commentsConfig from "@config/comments";
import { IComment } from "@defs/comment";
import { CommentsSort } from "@defs/types";

class CommentsStateHelper {
  /**
   * Recupera il valore di ordinamento memorizzato nel LocalStorage
   */
  public getSortValueFromLocalstorage = (): CommentsSort => {
    if (!window) {
      return null;
    }

    const stored = localStorage.getItem(commentsConfig.sort_name);

    if (stored && ["desc", "asc"].includes(stored)) {
      return <CommentsSort>stored;
    }
  };

  /**
   * Aggiorna il commento dopo l'eliminazione
   */
  public updateCommentsAfterDelete = (
    comments: IComment[],
    deleted: IComment
  ): IComment[] => {
    return comments.map((comment: IComment) => {
      if (comment.id === deleted.id) {
        return deleted;
      }

      return comment;
    });
  };

  /**
   * Rimuove il documento dai commenti dopo che è stato eliminato
   */
  public removeDocumentFromComment = (
    comments: IComment[],
    docId: string
  ): IComment[] => {
    return comments.map((comment) => {
      // Filtro i documenti del commento
      // Rimuovo quello corrispondente all'id passato nella action
      if (comment.documents) {
        const documents = comment.documents.filter((doc) => doc.id !== docId);

        // Ritorno il commento modificato
        return { ...comment, documents };
      }

      // Ritorno il commento originale
      return comment;
    });
  };
}

const commentsStateHelper = new CommentsStateHelper();

export default commentsStateHelper;
